import axios from 'axios'

import {
  Notification,
  MessageBox
} from 'element-ui'
import store from '../store'
import {
  getToken
} from '@/utils/auth'
import Config from '@/settings'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : '/', // api 的 base_url
  timeout: Config.timeout // 请求超时时间
})
// request拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Content-Type'] = 'application/json'



    if (config.method === 'get') {
      // 如果是 GET 请求，添加到 params
      if (!config.params) {
        config.params = {};
      }
      // config.params.mapType = sessionStorage.getItem('mapType') ? sessionStorage.getItem('mapType') : '1'; // 请替换为实际的值
    } else {
      // 如果是 POST, PUT 等请求，添加到 data
      if (!config.data) {
        config.data = {};
      }
      // config.data.mapType = sessionStorage.getItem('mapType') ? sessionStorage.getItem('mapType') : '1'; // 请替换为实际的值
    }


    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {

    const code = response.status
    if (code < 200 || code > 300) {
      Notification.error({
        title: response.message
      })
      return Promise.reject(error)
    } else {
      return response.data
    }
  },
  error => {
    let code = 0
    try {
      code = error.response.data.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Notification.error({
          title: '网络请求超时',
          duration: 5000
        })
        return Promise.reject(error)
      }
    }
    if (code) {
      if (code === 401) {
        Notification.error({
          title: '登录状态已过期，将退出登录',
          duration: 5000
        })
        setTimeout(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        }, 3000)
      } else if (code === 403) {
        router.push({
          path: '/401'
        })
      } else {
        const errorMsg = error.response.data.message
        if (errorMsg !== undefined) {
          // Notification.error({
          //   title: errorMsg,
          //   duration: 3000
          // })
        }
      }
    } else {
      Notification.error({
        title: '接口请求失败',
        duration: 5000
      })
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js